import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "ml-2 mr-2 flex justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "image", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons invisible" }, "image")
], -1)
const _hoisted_6 = {
  disabled: "",
  value: null
}
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  disabled: "",
  value: null
}
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  disabled: "",
  value: null
}
const _hoisted_11 = ["value"]
const _hoisted_12 = ["onClick", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onOpen && _ctx.onOpen(...args))),
        class: ""
      }, _hoisted_3),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$tc("dfraw.overlay")), 1),
      _hoisted_5
    ]),
    (_ctx.showPopup)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle(`width:${(_ctx.canvasParams.canw * 2) / 3}px; 
              left: ${_ctx.canvasOffset.x + _ctx.canvasParams.canw / 3}px; 
              top: ${_ctx.canvasOffset.y + _ctx.canvasParams.canh / 2}px`),
          class: "absolute border-2 border-solid border-blue-700 bg-slate-100"
        }, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select block w-full rounded border border-solid border-gray-300 bg-white bg-clip-padding bg-no-repeat px-3 py-1.5 text-base font-normal text-gray-700",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedProvider) = $event))
          }, [
            _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$tc("assetPicker.chooseProvider")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assetProviderInfos, (provider) => {
              return (_openBlock(), _createElementBlock("option", {
                key: provider.name,
                value: provider.key
              }, _toDisplayString(provider.name), 9, _hoisted_7))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.selectedProvider]
          ]),
          (_ctx.groupNames.length > 1)
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 0,
                class: "form-select block w-full rounded border border-solid border-gray-300 bg-white bg-clip-padding bg-no-repeat px-3 py-1.5 text-base font-normal text-gray-700",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedGroup) = $event))
              }, [
                _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$tc("assetPicker.chooseGroup")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupNames, (group) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: group,
                    value: group
                  }, _toDisplayString(group), 9, _hoisted_9))
                }), 128))
              ], 512)), [
                [_vModelSelect, _ctx.selectedGroup]
              ])
            : _createCommentVNode("", true),
          (_ctx.categoryNames.length > 1)
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 1,
                class: "form-select block w-full rounded border border-solid border-gray-300 bg-white bg-clip-padding bg-no-repeat px-3 py-1.5 text-base font-normal text-gray-700",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCategory) = $event))
              }, [
                _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.$tc("assetPicker.chooseGroup")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryNames, (category) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: category,
                    value: category
                  }, _toDisplayString(category), 9, _hoisted_11))
                }), 128))
              ], 512)), [
                [_vModelSelect, _ctx.selectedCategory]
              ])
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            style: _normalizeStyle(`width: 100%; height: ${
          _ctx.canvasParams.canh / 3
        }px; overflow-y: scroll`)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assetOverlays, (assetImage, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: assetImage.image
              }, [
                _createElementVNode("img", {
                  onClick: ($event: any) => (_ctx.onSelect(index)),
                  src: assetImage.image,
                  class: "mr-1 mb-1 inline-block w-14 rounded-xl"
                }, null, 8, _hoisted_12)
              ]))
            }), 128))
          ], 4)
        ], 4))
      : _createCommentVNode("", true)
  ]))
}